import * as types from './constants';
import { sortBy } from 'lodash';

const initialState = {
  data: [],
  getLoading: false,
  errors_api: {},
  popup: {
    resend: false,
    delete: false,
    verify: false,
    item: '',
    itemName: '',
    confirmAction: null
  }
};

const actions = {
  // Get Dashboard
  [types.GET_DASHBOARD_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_DASHBOARD_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: sortBy(payload, 'weight')
    };

    return { ...data };
  },

  [types.GET_DASHBOARD_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.SET_DASHBOARD_POPUP]: (state, { payload }) => {
    const data = {
      ...state,
      popup: {
        ...initialState.popup,
        ...payload
      }
    };

    return { ...data };
  },

  [types.CLEAR_DASHBOARD_POPUP]: state => {
    const data = {
      ...state,
      popup: initialState.popup
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};